import React from "react";
import { CircularProgress, Grid, makeStyles, Paper } from "@material-ui/core";
import BigLabelTextField from "../../StyledComponents/BigLabelTextField";
import { User } from "../../../shared-types/User";

const useStyles = makeStyles(theme => ({
  page: {
    width: "100vw",
    height: "81vh",
    padding: theme.spacing(6)
  }
}));

type ProfilePageProps = {
  user: User | null;
};

const ProfilePage: React.FC<ProfilePageProps> = ({ user }) => {
  const classes = useStyles();

  return (
    <Paper>
      <div className={classes.page}>
        <Grid
          direction="row"
          justify="center"
          alignItems="center"
          spacing={1}
          container
        >
          <Grid sm={1} lg={3} item></Grid>
          <Grid
            sm={6}
            lg={3}
            container
            direction="column"
            alignItems="center"
            justify="center"
            spacing={2}
            item
          >
            {user !== null ? (
              <>
                <Grid item container>
                  <BigLabelTextField
                    fullWidth
                    label="First Name"
                    placeholder={user.firstName}
                  />
                </Grid>
                <Grid item container>
                  <BigLabelTextField
                    fullWidth
                    label="Last Name"
                    placeholder={user.lastName}
                  />
                </Grid>
                <Grid item container>
                  <BigLabelTextField
                    fullWidth
                    label="Email Address"
                    placeholder={user.email}
                  />
                </Grid>
                <Grid item container>
                  <BigLabelTextField
                    fullWidth
                    label="Company / Organization"
                    placeholder={user.organization}
                  />
                </Grid>
              </>
            ) : (
              <CircularProgress color="secondary" />
            )}
          </Grid>
          <Grid sm={5} lg={6} item></Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default ProfilePage;
